import NewAdaptationModal from "./NewAdaptationModal";

export default NewAdaptationModal;
